import React from "react";

// Stylesheet
import "./Price.css";
import eth from "./../../../../assets/eth.svg";
import polygon from "./../../../../assets/matic.svg";
import ls from "localstorage-slim";

function Price({ price, setPrice, type, isSubmited }) {
  const validateInput = (e) => {
    // decimal number with 2 max decimal places can start with 0
    const regex = /^[0-9]*\.?[0-9]{0,5}$/;
    if (e.target.value === "") {
      setPrice("");
    } else if (regex.test(e.target.value)) {
      setPrice(e.target.value);
    } else {
      setPrice(e.target.value.slice(0, -1));
    }
  };

  return (
    <div className="form-price">
      <label>
        <b>Set A Price</b>
        <div className="cDivIcon" style={{ position: "relative !important" }}>
          <input
            value={price}
            type="text"
            name=""
            id=""
            className={
              "price-input" + (isSubmited && !price ? " errorField" : "")
            }
            onChange={validateInput}
            placeholder="Enter price for one piece"
          />

          {type && type === "Ethereum" ? (
            <img
              src={eth}
              style={{
                position: "absolute",
                right: "0px",
                top: "53%",
                transform: "translate(-50%, -50%)",
                width: "2%",
                filter: "brightness(150%)"
              }}
              alt="eth"
              width="100px"
            />
          ) : (
            <img
              src={polygon}
              style={{
                position: "absolute",
                right: "0px",
                top: "53%",
                transform: "translate(-50%, -50%)",
                width: "2%",
                filter: "brightness(150%)"
              }}
              alt="eth"
              width="100px"
            />
          )}
        </div>
      </label>
      <p className="yellow">Service fee 2.5%</p>
      <div className="flex-line">
        {type && type === "Ethereum" ? (
          <>
            <p>You will receive {(price - price * (2.5 / 100)).toPrecision(4)} ETH&nbsp;</p>
            <p className="yellow">
              ($ {((price - price * (2.5 / 100)) * ls.get("eth-usd")).toPrecision(3)} approx)
            </p>
          </>
        ) : (
          <>
            <p>You will receive {(price - price * (2.5 / 100)).toPrecision(4)} Matic &nbsp;</p>
            <p className="yellow">
              ($ {((price - price * (2.5 / 100)) * ls.get("matic-usd")).toPrecision(3)} approx)
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Price;
